import { ToneDto } from '../tonedto';

export interface FeaturedCategoryDto
{
    getTitle(): string;
    getListOfTones(): ToneDto[];
    getCategoryId(): number;
    getClientTxnId(): string;
    getIdentifier(): string;
    getMsisdn(): string;
    getLanguage(): string;
}

export class FeaturedCategoryDtoImpl implements FeaturedCategoryDto
{
    private title: string;
    private listOfTones: ToneDto[];
    private clientTxnId:string;
    private identifier:string;
    private msisdn:string;
    private language:string;
    private categoryId: number;

    getCategoryId(): number {
       return this.categoryId;
    }

    setCategoryId(categoryId:number)
    {
        this.categoryId = categoryId;
    }
    setTitle(title: string)
    {
        this.title = title;
    }
    getTitle(): string 
    {
        return this.title;
    }  

    setListOfTones(listOfTones: ToneDto[])
    {
        this.listOfTones = listOfTones;
    }
    getListOfTones(): ToneDto[] {
        return this.listOfTones;
    }

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string 
    {
        return this.clientTxnId;
    }

    setIdentifier(identifier: string)
    {
        this.identifier = identifier;
    }
    getIdentifier(): string 
    {
        return this.identifier;
    } 

    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    }

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/featuredcategory/featuredcategorydto.ts